module.exports = __webpack_public_path__ + "img/saturn6.ff40a60e.png";